import ZJApp from '../../../../app'

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'BaseDataService',
    controller: 'Grouppolling'
};

const methods = [
    'AddPollingGroup',
    'DelPollingGroup',
    'UpdatePollingGroup',
    'GetGroups'
];

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.get(path, data)
            // return this.post(path, data)
        }
    })
};

const SwiperVideoApi = ZJApi.defineNewApi('SwiperVideoApi', factory);

export default SwiperVideoApi;